import { observer } from 'mobx-react-lite';
import Modalcontainer from '../modalcontainer';
import { Approved } from '../modalcontainer/bodyContent/approved';
import { authorizationStore } from '../../modules/authorization/authorization.store';

const VerificationPopup = observer(() => {
  const { setOpenUnverifiedPopup, goToVerification } = authorizationStore;
  return (
    <Modalcontainer
      backBtn={false}
      closePopup={() => setOpenUnverifiedPopup(false)}
    >
      <Approved
        accept={{
          text: "Let's Go",
          color: 'primary',
        }}
        decline={{
          text: 'Not Now',
          color: 'roundedSecondary',
        }}
        declineAction={() => {
          setOpenUnverifiedPopup(false);
        }}
        acceptAction={() => {
          goToVerification();
          setOpenUnverifiedPopup(false);
        }}
        headerText={{
          title: 'Please Verify Your Profile!',
        }}
      />
    </Modalcontainer>
  );
});

export default VerificationPopup;

//
